import React from "react"
import { useProductCard } from "../../hooks/useProductCard"
import { Rating } from "../../../ui-shared/components/Rating"
import { emptyProductCardRating, productCardRating } from "./ProductCard.css"

export const ProductCardRating: React.FC = () => {
  const { productCardData } = useProductCard()
  if (!productCardData.rating) return <div className={emptyProductCardRating} />

  return (
    <div className={productCardRating}>
      <Rating
        totalReviews={productCardData.reviewCount}
        ratingValue={productCardData.rating}
      />
    </div>
  )
}
